import React from "react";
import { Box, Pagination, Typography } from "@mui/material";
import theme from "../../utils/theme";
const styles = {
  pagination: {
    width: "100%",
    backgroundColor: theme.palette.background.default,
    py: 1,
    display: "flex",
    alignItems: "center",
    gap: 2,
    justifyContent: "center",
    borderTop: "1px solid",
    borderColor: "divider",
  },
};

const PaginationComponent = ({ pagination, handlePageChange }) => {
  return (
    <Box sx={styles.pagination}>
      <Typography variant="body2">
        {(pagination.page - 1) * pagination.perPage + 1}-
        {Math.min(pagination.page * pagination.perPage, pagination.total)} of{" "}
        {pagination.total}
      </Typography>
      <Pagination
        count={pagination.totalPages}
        page={pagination.page}
        onChange={handlePageChange}
        color="primary"
        siblingCount={1}
        boundaryCount={1}
        // showFirstButton
        // showLastButton
      />
    </Box>
  );
};

export default PaginationComponent;
